import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';

import { DATA_TEST_ID } from '~constants/tests';
import { MODALS } from '~redux/Modal/constants';
import CustomModal from '~components/CustomModal';
import ModalActions from '~redux/Modal/actions';
import Text from '~components/Text';

import styles from './styles.module.scss';

const CloseSessionModal = () => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.modal[`${MODALS.SESSION_CLOSED}ModalIsOpen`]);
  const closeModal = () => dispatch(ModalActions.closeModal(MODALS.SESSION_CLOSED));
  return (
    <CustomModal hideCloseButton className={styles.modal} modal={MODALS.SESSION_CLOSED} isOpen={open}>
      <div className={`column ${styles.container}`}>
        <div className={`column full-width ${styles.contentContainer}`}>
          <div className={`row full-width middle center ${styles.headerContainer}`}>
            <Text
              data-testid={DATA_TEST_ID.logoutMessage}
              className="text-emperor text-uppercase bold center">
              {i18next.t('CloseSession:sessionClosed')}
            </Text>
          </div>
        </div>
        <div className={`row full-width middle center ${styles.footerContainer}`}>
          <button
            data-testid={DATA_TEST_ID.logoutCloseModal}
            type="button"
            className={`${styles.cancelButton} text-white body-font bold text-uppercase`}
            onClick={closeModal}>
            {i18next.t('CloseSession:close')}
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default CloseSessionModal;
